
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unacademy-centres-terms",
      function () {
        return require("private-next-pages/unacademy-centres-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unacademy-centres-terms"])
      });
    }
  